/* eslint-disable react-hooks/exhaustive-deps */
import { useReduxUser } from "./useReduxUser";
import { useReduxLookups } from "./useReduxLookups";

function useAppContext() {
  // Use the Redux hook instead of Context API
  return useReduxUser();
}

function useLookupsContext(isVendor) {
  // Use the Redux hook instead of Context API
  return useReduxLookups(isVendor);
}

export { useAppContext, useLookupsContext };
